const {
  required,
  requiredIf,
  between,
  maxLength,
} = require("vuelidate/lib/validators");
const getValidations = (vm) => {
  return {
    recruiterRemarks: {
      required,
      maxLength: maxLength(256),
    },
    feedback: {
      recommendation: { required },
      recOption: {
        required: requiredIf(() => {
          return vm.showRecOptions;
        }),
      },
    },
    feedbackform: {
      skills: {
        $each: {
          comments: {
            required: requiredIf((obj) => obj.commentMode && obj.mandatory),
            maxLength: maxLength(124),
          },
          mark: {
            required: requiredIf(
              (obj) => obj.markingType != "" && obj.mandatory
            ),
            between: between(1, 10),
          },
        },
      },
    },
  };
};
module.exports = {
  getValidations,
};
